import React from 'react';
import { Link } from 'react-router-dom';

const UnassignedNav = ({ authUser, signOut }) => {
  return (
    <div className='dropdown'>
      <a
        href='#/'
        className='d-inline-flex align-items-center link-dark text-decoration-none dropdown-toggle px-3 py-2 rounded-pill bg-white border shadow-xs transition-all hover-scale'
        data-bs-toggle='dropdown'
        aria-expanded='false'
        style={{ border: '1px solid #e2e8f0' }}
      >
        <div
          className='p-1 bg-warning bg-opacity-10 text-warning rounded-circle me-2 d-flex align-items-center justify-content-center'
          style={{ width: '32px', height: '32px' }}
        >
          <i className='bi bi-person-fill-exclamation small'></i>
        </div>
        <div className='text-start me-2'>
          <div
            className='fw-bold text-dark mb-0 leading-tight text-truncate'
            style={{ fontSize: '0.875rem', maxWidth: '120px' }}
          >
            {authUser?.fullName}
          </div>
          <div
            className='text-warning small fw-bold'
            style={{ fontSize: '0.72rem' }}
          >
            Belum Join Program
          </div>
        </div>
      </a>

      <ul
        className='dropdown-menu dropdown-menu-lg-end shadow-lg border-0 rounded-4 p-3 mt-2 mt-lg-3'
        style={{
          minWidth: '280px',
          border: '1px solid rgba(0,0,0,0.05)',
        }}
      >
        {/* User profile header info */}
        <li className='mb-3 text-center bg-light rounded-4 p-3 border border-light-subtle'>
          <div
            className='d-flex align-items-center justify-content-center bg-warning bg-opacity-10 text-warning rounded-circle mx-auto mb-2 fw-bold fs-5'
            style={{ width: '50px', height: '50px' }}
          >
            {authUser?.fullName?.substring(0, 2).toUpperCase()}
          </div>
          <h6 className='fw-bold text-dark mb-1 text-truncate'>
            {authUser?.fullName}
          </h6>
          <small className='text-muted d-block text-truncate mb-2'>
            {authUser?.email}
          </small>
          <span
            className='badge bg-warning bg-opacity-10 text-warning-emphasis border border-warning border-opacity-25 rounded-pill px-3 py-1 fw-bold extra-small'
            style={{ fontSize: '0.7rem' }}
          >
            Akun Baru (Belum Terdaftar)
          </span>
        </li>

        <li>
          <div className='px-2 py-1 mb-2'>
            <small
              className='text-uppercase fw-bold text-secondary text-xs'
              style={{ fontSize: '0.7rem', letterSpacing: '0.05em' }}
            >
              Langkah Selanjutnya
            </small>
          </div>
        </li>

        {/* Call to Action: Join Program */}
        <li>
          <Link
            className='dropdown-item d-flex align-items-center gap-3 p-2 rounded-3 hover-bg-light border border-transparent hover-border-light mb-2 transition-all'
            to='/program'
          >
            <div
              className='p-2 bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center flex-shrink-0'
              style={{ width: '36px', height: '36px' }}
            >
              <i className='bi bi-rocket-takeoff-fill fs-6'></i>
            </div>
            <div className='flex-grow-1 min-w-0'>
              <div
                className='fw-bold text-dark mb-0'
                style={{ fontSize: '0.85rem' }}
              >
                Daftar Program
              </div>
              <div
                className='text-muted text-xs'
                style={{ fontSize: '0.7rem' }}
              >
                Pilih & gabung program BCF
              </div>
            </div>
          </Link>
        </li>

        {/* Profile Settings */}
        {/* <li>
          <Link
            className='dropdown-item d-flex align-items-center gap-3 p-2 rounded-3 hover-bg-light border border-transparent hover-border-light mb-2 transition-all'
            to='/app/profile'
          >
            <div
              className='p-2 bg-info bg-opacity-10 text-info rounded-circle d-flex align-items-center justify-content-center flex-shrink-0'
              style={{ width: '36px', height: '36px' }}
            >
              <i className='bi bi-person-bounding-box fs-6'></i>
            </div>
            <div className='flex-grow-1 min-w-0'>
              <div
                className='fw-bold text-dark mb-0'
                style={{ fontSize: '0.85rem' }}
              >
                Lengkapi Profil
              </div>
              <div
                className='text-muted text-xs'
                style={{ fontSize: '0.7rem' }}
              >
                Data diri, akademik & domisili
              </div>
            </div>
          </Link>
        </li> */}

        <li>
          <hr className='dropdown-divider opacity-50 my-2' />
        </li>

        {/* Logout */}
        <li>
          <a
            onClick={(e) => {
              e.preventDefault();
              signOut();
            }}
            className='dropdown-item d-flex align-items-center gap-2 py-2 px-3 rounded-3 text-danger transition-all'
            href='#/'
          >
            <i className='bi bi-box-arrow-right'></i>
            <span className='fw-bold'>Sign out</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default UnassignedNav;
